<template>
  <div class="login">
    <div class="login_head">
      <img :src="loginImagesList[0].img" alt="">
    </div>
    <div class="login_content">
      <div class="login_content_one">
        <span><img src="../../assets/images/login_07.jpg" alt=""></span>
        <input type="text" placeholder="请输入手机号" v-model="tel">
      </div>
      <div class="login_content_otwo clearfix">
        <div class="login_content_two clearfix">
          <span><img src="../../assets/images/login_10.jpg" alt=""></span>
          <input type="text" placeholder="请输入验证码" v-model="code">
        </div>
        <button @click="_code" v-if="outtime">{{codetext}}</button>
        <button v-else>{{outnum}}秒</button>
      </div>

      <p>{{telerror}}</p>
      <button @click="_login()">登录</button>
    </div>
  </div>
</template>

<script>
import {
  getCode,
  getLogin,
  getHomePage
} from "@/api/api";
import common from '@/libs/common'
  export default{
    name: 'Login',
     data () {
      return{
        tel:"",
        code:"",
        telerror:"",
        outtime:true,
        outnum:120,
        cinterval:null,
        codetext:"验证码",
        loginImagesList: []
      }
    },
    methods: {
      getHomePage() {
        getHomePage().then(res => {
          this.loginImagesList = res.data.data.loginImagesList || [];
        })
      },
      _login() {
        if(this.code && this.tel) {
          const data = {
            code: this.code,
            mobile: this.tel
          }
          getLogin(data).then(res => {
            common.setUserInfo(res.data.data.userInfo);
            common.setToken(res.data.data.token);
            this.$router.replace({name: 'Home'});
            window.location.reload();
          })
        }else{
          this.$message.warning('请输入手机号码和验证码！');
        }
      },
      _code() {
        clearInterval(this.cinterval);
        if(this.tel) {
          const loading = this.$loading({
            lock: true,
            text: '发送中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          getCode(this.tel).then(res => {
            loading.close();
            if(res.data.code === 0){
               console.log(res)
              this.outtime = false;
              this._time();
              this.telerror = "短信发送成功(30分钟内有效)，请查收~";
            }
          })
        }else{
          this.$message.warning('请输入手机号码');
        }
      },
       _time:function () {
        var _this = this;
        _this.outnum = 120;
        if(this.outtime === false){
          _this.cinterval = setInterval(function () {
            _this.outnum--;
            if(_this.outnum == 0){
              _this.outnum = 0;
              _this.codetext = "重新获取";
              _this.outtime = true;
              clearInterval(_this.cinterval);
            }
          },1000)
        }
      },
    },
    mounted(){
      this.getHomePage();
      window.scroll(0, 135);
    }
  }

</script>

<style>
  .login{width: 1000px;margin: 0 auto}
  .login_head{width: 1000px}
  .login_head img{width: 100%}
  .login_content{text-align: center;margin: 80px 0}
  .login_content img{vertical-align: middle;margin-bottom: 3px;}
  .login_content span{display: inline-block;height:40px;margin-left: 10px}
  .login_content_one input{width: 200px;height:35px;display:inline-block;margin-bottom: 20px;box-sizing: border-box;border: none}
  .login_content_one{width: 250px; text-align: left;  margin: 0 auto 30px auto;border: 1px solid gainsboro;height: 40px;line-height: 40px;border-radius: 4px;}
  .login_content_two{width: 160px;float: left;text-align: left;  margin: 0 auto 40px;border: 1px solid gainsboro;height: 40px;line-height: 40px;border-radius: 4px;display: inline-block}
  .login_content_two input{width: 120px;height:35px;display:inline-block;vertical-align: middle;box-sizing: border-box;border: none}
  .login_content_otwo{width: 250px;margin: 0 auto}
  .login_content_otwo button{width: 85px;height: 42px;display:inline-block;color:#6d1a22;border: 1px solid gainsboro;border-radius: 4px;background-color: white;vertical-align: middle;cursor: pointer}
  .login_content>button{width: 100px;height: 35px;display:inline-block;color:white;border: 1px solid #000000;border-radius: 4px;background-color: black;vertical-align: middle;cursor: pointer;letter-spacing: 10px;text-align: center;text-indent: 10px;}
  .login_content>p{color:#6d1a22 }
  .login_content input:focus{border-color: #0b8bff  }
</style>
